<template>
  <v-container fluid class="px-0">
    <v-card ref="form">
      <v-card-title class="modalTitle pb-3 mb-3">
        <h2 ref="detailObjektas">{{ tekstas.modalTitle }}</h2>
      </v-card-title>

      <v-card-text>
        <el-overlay-loading :loading="pageloading" />
        <v-row>
          <v-col cols="12">
            <el-textarea
              need
              :label="labels.name"
              :tooltip="labels.nameTooltip"
              :counter="3000"
              :readonly="readonly"
              v-model="formData.pri_pavadinimas"
              autofocus
            />
          </v-col>
          <v-col cols="6">
            <el-money-field
              need
              :label="labelDydis"
              :tooltip="tooltipDydis"
              :readonly="readonly"
              v-model="formData.pri_dydis"
            />
          </v-col>
          <v-col cols="6">
            <el-autocomplete
              need
              :items="valiutos"
              itemvalue="value"
              itemtext="text"
              label="Valiuta"
              tooltip="Hipoteka. Prievolė. Valiuta"
              :readonly="readonly"
              v-model="formData.pri_valiuta"
            />
          </v-col>
          <v-col cols="12" v-if="showNetesybos">
            <el-checkbox
              class="mb-4"
              :label="labels.netesybos"
              :tooltip="labels.netesybosTooltip"
              :readonly="readonly"
              v-model="formData.pri_netesybos"
            />
          </v-col>
          <template v-if="showAtlyginimas">
            <v-col cols="12">
              <p class="field-label text-inline">
                {{ labels.atlyginimas }}
                <el-tooltip :tooltip="labels.atlyginimasTooltip" />
              </p>
              <el-textarea
                class="required-input pt-0"
                :counter="4000"
                :readonly="readonly"
                v-model="formData.pri_kreditoriaus_atlyginimas"
              />
            </v-col>
          </template>
          <template v-if="showFiksavimoData">
            <v-col cols="12" md="6">
              <el-date-picker
                label="Skolos dydžio fiksavimo data"
                tooltip="Hipoteka. Prievolė. Skolos dydžio fiksavimo data"
                :readonly="readonly"
                :disabled="!enableSkolosData"
                v-model="formData.pri_skolos_data"
              />
            </v-col>
            <v-col cols="12" md="6">
              <el-checkbox
                v-if="isMaksimalus"
                class="mt-3"
                label="Nenustatoma"
                tooltip="Hipoteka. Prievolė. Skolos dydžio fiksavimo data nenustatoma"
                :readonly="readonly"
                v-model="formData.pri_skolos_data_nenustatoma"
              />
            </v-col>
          </template>
          <v-col cols="12" md="6">
            <el-date-picker
              futureDates
              :label="labels.terminasData"
              :tooltip="labels.terminasDataTooltip"
              :readonly="readonly"
              v-model="formData.pri_terminas_data"
            />
          </v-col>
          <v-col cols="12">
            <el-textarea
              :label="labels.terminas"
              :tooltip="labels.terminasTooltip"
              :counter="2000"
              :readonly="readonly"
              v-model="formData.pri_terminas"
            />
          </v-col>
        </v-row>

        <v-footer class="form-footer mt-3">
          <el-button
            v-if="!readonly"
            primary
            @click.native="saveData(null, 'close')"
            :loading="loading"
            >Saugoti</el-button
          >
          <el-button
            v-if="!readonly"
            @click.native="cancelData()"
            :loading="loading"
            >Atšaukti</el-button
          >
          <v-spacer></v-spacer>
          <el-button
            primary
            v-if="!readonly"
            @click.native="checkErrorsClick()"
            :loading="loading"
            >Tikrinti</el-button
          >
        </v-footer>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import HipotekaMap from './../hipotekaMap'
import unsavedData from '../../../mixins/unsavedData'
import checkErrors from '../../../mixins/checkErrors'

export default {
  name: 'PrievoleObjektas',
  props: {
    valiutos: Array,
    labels: Object,
    readonly: Boolean,
  },
  mixins: [unsavedData, checkErrors],
  data() {
    return {
      pageloading: true,
      loading: true,
      formData: {
        pri_valiuta: 'EUR',
        pri_netesybos: true,
        pri_skolos_data_nenustatoma: true,
      },
      testas: null,
    }
  },
  $_veeValidate: {
    validator: 'new',
  },
  computed: {
    ...mapGetters([
      'objektasID',
      'hipotekaTipas',
      'prievoleID',
      'objektasRusys',
    ]),
    tekstas() {
      const key = Object.keys(HipotekaMap['prievoleTekstas']).find(e =>
        this.hipotekaTipas.includes(e)
      )
      return key ? HipotekaMap['prievoleTekstas'][key] : {}
    },
    labelDydis() {
      return this.formData.pri_netesybos
        ? this.labels.dydisKreditoriui
        : this.labels.dydis
    },
    tooltipDydis() {
      return this.formData.pri_netesybos
        ? this.labels.dydisKreditoriuiTooltip
        : this.labels.dydisTooltip
    },
    showNetesybos() {
      return this.labels.netesybos !== ''
    },
    showAtlyginimas() {
      return this.showNetesybos && !this.formData.pri_netesybos
    },
    showFiksavimoData() {
      return this.labels.netesybos !== ''
    },
    enableSkolosData() {
      return !this.formData.pri_skolos_data_nenustatoma
    },
    isMaksimalus() {
      return this.objektasRusys.maksimalus
    },
  },
  created() {
    this.$store.dispatch('prievoleID', this.$route.params.prievoleID)
    this.getData(true)
  },
  methods: {
    getData(firstLoad = false) {
      if (this.prievoleID === 0) {
        this.newPrievole()
        return
      }
      this.pageloading = true
      this.loading = true
      this.$axios
        .get(`objektas/${this.objektasID}/prievole/${this.prievoleID}`)
        .then(res => {
          this.formData = res.data.prievole
          this.initialForm()
        })
        .catch(err => {
          this.cancelData()
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.pageloading = false
          this.loading = false
          if (firstLoad) {
            this.$nextTick(() => {
              this.$vuetify.goTo(this.$refs.detailObjektas)
            })
          } else {
            this.$root.$emit('updatePrievoleList')
          }
        })
    },
    newPrievole() {
      this.pageloading = false
      this.loading = false
      this.initialForm()
    },
    saveData(toRoute, afterSave) {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.loading = true
          let data = this.formData
          data.obj_id = this.objektasID

          this.$axios
            .post(`objektas/${this.objektasID}/prievole`, data)
            .then(res => {
              this.$root.$emit('updatePrievoleList')
              window._VMA.$emit('DATA_OK', 'Duomenys išsaugoti')

              if (toRoute) {
                this.goToRoute()
              } else {
                this.formData = res.data.prievole
                this.initialForm()
                if (afterSave === 'checkErrors') {
                  this.checkErrors()
                }
                if (afterSave === 'close') {
                  this.closePrievole()
                }
              }
            })
            .catch(err => {
              window._VMA.$emit('DATA_ERROR', err.response.data.message)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          window._VMA.$emit('FORMAT_ERROR')
          this.$root.$emit('cancelTabNavigation')
        }
      })
    },
    cancelData() {
      this.$store.dispatch('unsavedData', false).then(() => {
        this.closePrievole()
      })
    },
    closePrievole() {
      this.$emit('closePrievole')
    },
    checkErrorsClick() {
      this.saveData(null, 'checkErrors')
    },
  },
}
</script>
<style lang="scss" scoped></style>
